import { XAxisProps } from "recharts";

export function xAxisConfig(options?: XAxisProps) {
  const { height = 52, ...rest } = options ?? {};

  return {
    dataKey: "name",
    type: "number" as const,
    scale: "linear" as const,
    domain: ["dataMin", "dataMax"] as const,
    allowDataOverflow: true,
    tickCount: 6,
    tickMargin: 10,
    tickFormatter: (v: number) => String(Math.round(v)),
    height,
    stroke: "rgba(255,255,255,0.12)",
    tick: { fill: "rgba(255,255,255,0.55)", fontSize: 11 },
    tickLine: false,
    ...rest,
  } as XAxisProps;
}

export default xAxisConfig;
